export default __webpack_public_path__ + "static/media/thank-character.da36c0ca.svg";